<template>
    <v-row class="mx-0">
        <v-col cols="12" class="d-flex justify-center">
            <v-card width="100%" max-width="800px">
                <div class="d-flex justify-center title pa-4 text-center">{{ $t('orderSuccess') }}</div>
                <v-divider></v-divider>
                <v-card-text v-if="orderData.responseData.success && orderData.responseData.success.length">
                    <v-row
                            dense
                            v-if="orderData.responseData.success && orderData.responseData.success.length"
                            v-for="order in orderData.responseData.success"
                            :key="order.seller.id"
                    >
                        <v-col cols="12" class="title">{{ sellerName(order) }}</v-col>
                        <v-col cols="12">
                            <v-data-table
                                    hide-default-footer
                                    disable-sort
                                    disable-pagination
                                    class="no-mobile-header"
                                    :footer-props="{ disablePagination: true }"
                                    :header-props="{ disableSort: true }"
                                    :headers="headersGroupGeneral"
                                    :items="getOrderGeneral(order)"
                            ></v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text v-if="orderData.responseData.error && orderData.responseData.error.length">
                    <v-row dense v-for="(error, idx) in orderData.responseData.error" :key="idx">
                        <v-col cols="12" class="red lighten-4">{{ error }}</v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex flex-wrap justify-center justify-md-space-around">
                    <v-btn
                            class="px-4 my-4 test-white"
                            color="main--yellow"
                            depressed
                            :disabled="!basketItems.length"
                            @click="resetOrderResponse"
                    >{{ $t('backToOrders') }}</v-btn>
                    <v-btn
                            class="px-4 my-4 test-white"
                            to="/profile/basket"
                            color="main--yellow"
                            dark
                            depressed
                    >{{ $t('myBasket') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import OrderDataProvider from '../../../../app-front/mixins/OrderDataProvider';

    export default {
        name: "OrderResponse",
        mixins: [OrderDataProvider],
        data() {
            return {
                headersGroupGeneral: [
                    {
                        text: 'Товар',
                        align: 'start',
                        value: 'name'
                    },
                    {
                        text: 'Номер заказа',
                        align: 'start',
                        value: 'orderNumber'
                    },
                    {
                        text: 'Кол-во',
                        align: 'start',
                        value: 'quantity'
                    },
                    {
                        text: 'Цена',
                        align: 'start',
                        value: 'price'
                    },
                    {
                        text: 'Поставка',
                        align: 'start',
                        value: 'dateDelivery'
                    },
                ]
            }
        },
        methods: {
            sellerName(order) {
                return order.seller.companyName || `${order.seller.lastName} ${order.seller.firstName}`;
            },
            getOrderGeneral(order) {
                const dateDelivery = order.products[0].dateDelivery;

                return order.products.map(item => {
                    return {
                        name: item.name,
                        orderNumber: item.orderNumber,
                        price: item.priceDiscounted || item.price,
                        quantity: item.quantity,
                        dateDelivery: dateDelivery,
                    }
                });
            }
        },
    }
</script>

<style scoped>

</style>
